import { useCallback } from "react";
import useWeb3 from "../useWeb3";
import { getBalance } from "../../utils/contractHelpers";
import { useWeb3React } from "@web3-react/core";


const BalanceOfRock = () => {
    const { account } = useWeb3React();
    const web3 = useWeb3();
    const BalanceOfRockHook = useCallback(
        async (contractAddress) => {
            const contract = getBalance(contractAddress, web3);
            if (!contract) {
                console.error("Contract not initialized properly.");
                return;
            }
            try {
                const balance = await contract?.methods?.balanceOf(account)?.call();
                const formattedBalance = web3.utils.fromWei(String(balance), 'ether');
                return formattedBalance;
            } catch (error) {
                console.error("Error fetching balance:", error.message || error);
                throw error;
            }
        },
        [account]
    );
    return { BalanceOfRockHook };
};

export default BalanceOfRock;


